import React from "react";

import { Box } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";

export default function MenuTab() {
  const navigate = useNavigate();

  React.useEffect(() => {}, []);

  return (
    <Box style={{ width: "100%" }}>
      <Outlet />
    </Box>
  );
}
